<template lang="pug">
.hx-main.hdpouOdds.visible
  //- small {{ details }}
  .hx-table.hx-match(:class='{ live: source.marketId == 3, alternate: source.matchIndex % 2 == 0 }')
    .hx-cell.w-62
      .hx-row.h-100.hx-rows
        timePanel(:source="source")
    .hx-cell.flex-fill
      .hx-row.h-100.hx-rows
        xTeam(:source="source", isDraw, cls="w-193")
        xFavorite(:source="source")
    .hx-cell.w-262
      .hx-row.hx-rows(
        v-for="(dn, i) in details['kns']"
        :class="(details['oxt'] != null && details['oxt'][i] != null) || (details['oxth'] != null && details['oxth'][i] != null) ? 'h-66' : ''"
        )
        hdpItem(:details="details", :oddsType="oddsType", :i="i", betType="hdp")
        ouItem(:details="details", :oddsType="oddsType", :i="i", betType="ou")
        oxtItem(:details="details", :oddsType="oddsType", :i="i", betType="oxt")
    .hx-cell.w-262
      .hx-row.hx-rows(
        v-for="(dn, i) in details['kns']",
        :class="(details['oxt'] != null && details['oxt'][i] != null) || (details['oxth'] != null && details['oxth'][i] != null) ? 'h-66' : ''")
        hdpItem(:details="details", :oddsType="oddsType", :i="i", betType="hdph")
        ouItem(:details="details", :oddsType="oddsType", :i="i", betType="ouh")
        oxtItem(:details="details", :oddsType="oddsType", :i="i", betType="oxth")
    .hx-cell.w-40
      .hx-row.h-100.hx-rows
        .hx-col.hx-cols.w-100.d-flex.align-items-center.justify-content-center
          template(v-if="details['more'] > 0")
            .hx-more(
              :class="single ? '' : 'collapsed'",
              :id="'morehead_' + id",
              data-toggle="collapse",
              :aria-expanded="false",
              :data-target="'#morebet_' + id",
              :aria-controls="'morebet_' + id",
              @click="handleMore(matchId, $event.target)"
            )
              i.far.fa-chevron-up
              span &nbsp;{{ details['more'] }}

  template(v-if="details['more'] > 0")
    .hx-table.hx-match.hx-morebet.collapse(
      :id="'morebet_' + id",
      :aria-labelledby="'morehead_' + id",
      data-parent="#hdpou",
      :class="{ live: source.marketId == 3, alternate: source.matchIndex % 2 == 0, show: single }"
    )
      morePanel(
        v-if="source.matchId == selectedMatch"
        ref="morePanel",
        :uid="id",
        :details="moreItems",
        :child1Ids="details['child1']",
        :child2Ids="details['child2']",
        :matchId="matchId",
        :leagueId="leagueId",
        :marketType="marketType",
        :sportsType="sportsType",
        :betType="betType",
        :layoutIndex="layoutIndex"
      )
</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    timePanel: () => import("@/components/desktop/main/xtable/timePanel"),
    morePanel: () => import("@/components/desktop/main/xheader/morePanel"),
    xTeam: () => import("@/components/desktop/main/xtable/xitem/xTeam"),
    xFavorite: () => import("@/components/desktop/main/xtable/xitem/xFavorite"),
    hdpItem: () => import("@/components/desktop/main/xtable/xitem/hdpItem"),
    ouItem: () => import("@/components/desktop/main/xtable/xitem/ouItem"),
    oxtItem: () => import("@/components/desktop/main/xtable/xitem/oxtItem")
  },
  mixins: [mixinHDPOUOdds],
  mounted() {
    setTimeout(() => {
      if (this.source.matchId == this.selectedMatch) {
        this.$nextTick(() => {
          var test = $("#morehead_" + this.id);
          test.removeClass("collapsed");
          test.attr("aria-expanded", "true");
          $("#morebet_" + this.id).addClass("show");
        });
      }
    }, 500);
  },
  methods: {},
};
</script>
